// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import dataTableStyles from "@conklin/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { tableStyles } from "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryTable";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

tableStyles.noResultsContainer = {
    ...dataTableStyles.noResultsContainer,
};

tableStyles.noResultsText = {
    ...dataTableStyles.noResultsText,
};

tableStyles.totalHeader = {
    alignX: "left",
};

tableStyles.currentBalanceHeader = {
    alignX: "left",
};

tableStyles.totalCell = {
    alignX: "left",
};

tableStyles.currentBalanceCell = {
    alignX: "left",
};

tableStyles.shipToCell = {
    css: css`
        ${TypographyStyle} {
            white-space: normal;
        }
    `,
};

tableStyles.shipToHeader = {
    tight: false,
};

tableStyles.dataTable = {
    css: css`
        [data-test-selector="invoiceHistory_invoiceLine_shipTo"] [class^="ValueTypography"] {
            white-space: normal;
        }
    `,
};
